import Cookies from 'js-cookie'
import api from '../api'
import { RelatedProductResponse } from '../linx-api/dtos'

export const getShowCase = async (
  source: 'desktop' | 'mobile' = 'desktop',
  name: string
) => {
  const deviceId = Cookies.get('nav_id') ?? null

  const { data } = await api.get<RelatedProductResponse>(
    `/canais/vitrine?name=${name}&source=${source}${
      deviceId ? `&deviceId=${deviceId}` : ''
    }`
  )
  return data
}
